export default "__VITE_ASSET__0We8nKkx__"